import { render, staticRenderFns } from "./OfficialLabelsWork.vue?vue&type=template&id=8e4f4838&scoped=true&class=h-100"
import script from "./OfficialLabelsWork.vue?vue&type=script&lang=ts"
export * from "./OfficialLabelsWork.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4f4838",
  null
  
)

export default component.exports